import { useEffect } from "react";
import { registerInteraction } from "../features/interaction_factory/InteractionFactory";
import { InteractionType } from "../models/interactions/Interaction";
import { audioPopupInteraction } from "../models/interactions/AudioPopup";
import { ambientAudioInteraction } from "../models/interactions/AmbientAudio";
import { clickRegionInteraction } from "../models/interactions/ClickRegion";
import { clickRegionMultiSelectQuizInteraction } from "../models/interactions/ClickRegionMultiSelectQuiz";
import { clickRegionOrderQuizInteraction } from "../models/interactions/ClickRegionOrderQuiz";
import { connectGraphicsQuizInteraction } from "../models/interactions/ConnectGraphicsQuiz";
import { connectQuizInteraction } from "../models/interactions/ConnectQuiz";
import { labelDragAndDropQuizInteraction } from "../models/interactions/LabelDragAndDropQuiz";
import { propLabelOrderQuizInteraction } from "../models/interactions/PropLabelOrderQuiz";
import { propLabelQuizInteraction } from "../models/interactions/PropLabelQuiz";
import { imageDragAndDropQuizInteraction } from "../models/interactions/ImageDragAndDropQuiz";
import { conversationInteraction } from "../models/interactions/Conversation";
import { dialogQuizInteraction } from "../models/interactions/DialogQuiz";
import { dynamicInteraction } from "../models/interactions/DynamicInteraction";
import { emotionBubbleInteraction } from "../models/interactions/EmotionBubble";
import { grabInteraction } from "../models/interactions/Grab";
import { imagePopupInteraction } from "../models/interactions/ImagePopup";
import { lisaMessageInteraction } from "../models/interactions/LisaMessage";
import { markerInteraction } from "../models/interactions/Marker";
import { messageBubbleInteraction } from "../models/interactions/MessageBubble";
import { messagePopupInteraction } from "../models/interactions/MessagePopup";
import { multipleChoiceGraphicsQuizInteraction } from "../models/interactions/MultipleChoiceGraphicsQuiz";
import { multipleChoiceQuizInteraction } from "../models/interactions/MultipleChoiceQuiz";
import { multiSelectGraphicsQuizInteraction } from "../models/interactions/MultiSelectGraphicsQuiz";
import { multiSelectQuizInteraction } from "../models/interactions/MultiselectQuiz";
import { createOrderGraphicsQuiz } from "../models/interactions/OrderGraphicsQuiz";
import { orderQuizInteraction } from "../models/interactions/OrderQuiz";
import { pdfPopupInteraction } from "../models/interactions/PdfPopup";
import { photoRangeQuizInteraction } from "../models/interactions/PhotoRangeQuiz";
import { scrabbleQuizInteraction } from "../models/interactions/ScrabbleQuiz";
import { videoPopupInteraction } from "../models/interactions/VideoPopup";
import { wordQuizInteraction } from "../models/interactions/WordQuiz";
import { wordSpinnerQuizInteraction } from "../models/interactions/WordSpinnerQuiz";
import TeleportMarkerInteraction from "../models/interactions/TeleportMarker";
import { detachInteraction } from "../models/interactions/Detach";
import { attachInteraction } from "../models/interactions/Attach";
import { slideshowInteraction } from "../models/interactions/Slideshow";
import { buttonsQuizInteraction } from "../models/interactions/ButtonsQuiz";
import { lookatInteraction } from "../models/interactions/Lookat";
import { setPropStateInteraction } from "../models/interactions/SetPropState";
import { ShowUIPropInteraction } from "../models/interactions/ShowUIProp";
import { HideUIPropInteraction } from "../models/interactions/HideUIProp";
import { ImageButtonQuizInteraction } from "../models/interactions/ImageButtonQuiz";
import { clickIndicatorInteraction } from "../models/interactions/ClickIndicator";
import { hideClickIndicatorInteraction } from "../models/interactions/HideClickIndicator";
import { waitForClickInteraction } from "../models/interactions/WaitForClick";
import { statementQuizInteraction } from "../models/interactions/StatementQuiz";
import { showCustomQuizInteraction } from "../models/interactions/ShowCustomQuiz";
import { loseCustomQuizStarInteraction } from "../models/interactions/LoseCustomQuizStar";
import { closeCustomQuizInteraction } from "../models/interactions/CloseCustomQuiz";
import { setCameraInteraction } from "../models/interactions/SetCamera";
import { inspectPropInteraction } from "../models/interactions/InspectProp";
import { waitInteraction } from "../models/interactions/Wait";
import { setCharacterPartsInteraction } from "../models/interactions/SetCharacterParts";
import { clearCharacterPartsInteraction } from "../models/interactions/ClearCharacterParts";
import { setOutfitInteraction } from "../models/interactions/SetOutfit";
import { sequenceInteraction } from "../models/interactions/Sequence";
import { parallelSequenceInteraction } from "../models/interactions/ParallelSequence";
import { animateActorInteraction } from "../models/AnimateActor";
import { stopWalkingInteraction } from "../models/interactions/StopWalking";
import { proximityTriggerInteraction } from "../models/interactions/ProximityTrigger";
import { sendActorToPositionInteraction } from "../models/interactions/SendActorToPosition";
import { subSequenceInteraction } from "../models/interactions/SubSequence";
import { playSubSequenceInteraction } from "../models/interactions/PlaySubSequence";
import { stopSubSequenceInteraction } from "../models/interactions/StopSubSequence";
import { triggerInteraction } from "../models/interactions/Trigger";
import { triggerEventInteraction } from "../models/interactions/TriggerEvent";
import { waitForEventInteraction } from "../models/interactions/WaitForEvent";
import { transitionInteraction } from "../models/interactions/Transition";
import { showLetterBoxInteraction } from "../models/interactions/ShowLetterBox";
import { hideLetterBoxInteraction } from "../models/interactions/HideLetterBox";
import { ifInteraction } from "../models/interactions/If";
import { switchInteraction } from "../models/interactions/Switch";
import { mathInteraction } from "../models/interactions/Math";
import { setVariableInteraction } from "../models/interactions/SetVariable";
import { setMovementEnabledInteraction } from "../models/interactions/SetMovementEnabled";
import { enableDefaultCameraInteraction } from "../models/interactions/EnableDefaultCamera";
import { powerSlideInteraction } from "../models/interactions/PowerSlide";
import { initializeTimerInteraction } from "../models/interactions/InitializeTimer";
import { updateTimerInteraction } from "../models/interactions/UpdateTimer";
import { getTimerTimeInteraction } from "../models/interactions/GetTimerTime";

export default function useInteractionFactoryImports() {
  useEffect(() => {
    registerInteraction(
      InteractionType.AmbientAudio,
      ambientAudioInteraction()
    );
    registerInteraction(InteractionType.AudioPopup, audioPopupInteraction());
    registerInteraction(InteractionType.ClickRegion, clickRegionInteraction());
    registerInteraction(
      InteractionType.ClickRegionMultiSelectQuiz,
      clickRegionMultiSelectQuizInteraction()
    );
    registerInteraction(
      InteractionType.ClickRegionOrderQuiz,
      clickRegionOrderQuizInteraction()
    );
    registerInteraction(
      InteractionType.ConnectGraphicsQuiz,
      connectGraphicsQuizInteraction()
    );
    registerInteraction(
      InteractionType.LabelDragAndDropQuiz,
      labelDragAndDropQuizInteraction()
    );
    registerInteraction(
      InteractionType.PropLabelQuiz,
      propLabelQuizInteraction()
    );
    registerInteraction(
      InteractionType.PropLabelOrderQuiz,
      propLabelOrderQuizInteraction()
    );
    registerInteraction(
      InteractionType.ImageDragAndDropQuiz,
      imageDragAndDropQuizInteraction()
    );
    registerInteraction(InteractionType.ConnectQuiz, connectQuizInteraction());
    registerInteraction(
      InteractionType.Conversation,
      conversationInteraction()
    );
    registerInteraction(InteractionType.DialogQuiz, dialogQuizInteraction());
    registerInteraction(
      InteractionType.DynamicInteraction,
      dynamicInteraction()
    );
    registerInteraction(
      InteractionType.EmotionBubble,
      emotionBubbleInteraction()
    );
    registerInteraction(InteractionType.Grab, grabInteraction());
    registerInteraction(InteractionType.ImagePopup, imagePopupInteraction());
    registerInteraction(InteractionType.LisaMessage, lisaMessageInteraction());
    registerInteraction(InteractionType.Marker, markerInteraction());
    registerInteraction(
      InteractionType.MessageBubble,
      messageBubbleInteraction()
    );
    registerInteraction(
      InteractionType.MessagePopup,
      messagePopupInteraction()
    );
    registerInteraction(
      InteractionType.MultipleChoiceGraphicsQuiz,
      multipleChoiceGraphicsQuizInteraction()
    );
    registerInteraction(
      InteractionType.MultipleChoiceQuiz,
      multipleChoiceQuizInteraction()
    );
    registerInteraction(
      InteractionType.MultiSelectGraphicsQuiz,
      multiSelectGraphicsQuizInteraction()
    );
    registerInteraction(
      InteractionType.MultiselectQuiz,
      multiSelectQuizInteraction()
    );
    registerInteraction(
      InteractionType.OrderGraphicsQuiz,
      createOrderGraphicsQuiz()
    );
    registerInteraction(InteractionType.OrderQuiz, orderQuizInteraction());
    registerInteraction(InteractionType.PdfPopup, pdfPopupInteraction());
    registerInteraction(
      InteractionType.PhotoRangeQuiz,
      photoRangeQuizInteraction()
    );
    registerInteraction(
      InteractionType.ScrabbleQuiz,
      scrabbleQuizInteraction()
    );
    registerInteraction(InteractionType.VideoPopup, videoPopupInteraction());
    registerInteraction(InteractionType.WordQuiz, wordQuizInteraction());
    registerInteraction(
      InteractionType.WordSpinnerQuiz,
      wordSpinnerQuizInteraction()
    );
    registerInteraction(InteractionType.Detach, detachInteraction());
    registerInteraction(InteractionType.Attach, attachInteraction());
    registerInteraction(InteractionType.Slideshow, slideshowInteraction());
    registerInteraction(InteractionType.ButtonsQuiz, buttonsQuizInteraction());
    registerInteraction(
      InteractionType.TeleportMarker,
      TeleportMarkerInteraction()
    );
    registerInteraction(InteractionType.Lookat, lookatInteraction());
    registerInteraction(
      InteractionType.SetPropState,
      setPropStateInteraction()
    );
    registerInteraction(InteractionType.ShowUIProp, ShowUIPropInteraction());
    registerInteraction(InteractionType.HideUIProp, HideUIPropInteraction());
    registerInteraction(
      InteractionType.ImageButtonQuiz,
      ImageButtonQuizInteraction()
    );
    registerInteraction(
      InteractionType.ClickIndicator,
      clickIndicatorInteraction()
    );
    registerInteraction(
      InteractionType.HideClickIndicator,
      hideClickIndicatorInteraction()
    );
    registerInteraction(
      InteractionType.WaitForClick,
      waitForClickInteraction()
    );
    registerInteraction(
      InteractionType.StatementQuiz,
      statementQuizInteraction()
    );
    registerInteraction(
      InteractionType.ShowCustomQuiz,
      showCustomQuizInteraction()
    );
    registerInteraction(
      InteractionType.LoseCustomQuizStar,
      loseCustomQuizStarInteraction()
    );
    registerInteraction(
      InteractionType.CloseCustomQuiz,
      closeCustomQuizInteraction()
    );
    registerInteraction(InteractionType.SetCamera, setCameraInteraction());
    registerInteraction(InteractionType.InspectProp, inspectPropInteraction());
    registerInteraction(InteractionType.Wait, waitInteraction());
    registerInteraction(
      InteractionType.SetCharacterParts,
      setCharacterPartsInteraction()
    );
    registerInteraction(
      InteractionType.ClearCharacterParts,
      clearCharacterPartsInteraction()
    );
    registerInteraction(InteractionType.SetOutfit, setOutfitInteraction());
    registerInteraction(InteractionType.Sequence, sequenceInteraction());
    registerInteraction(
      InteractionType.ParallelSequence,
      parallelSequenceInteraction()
    );
    registerInteraction(
      InteractionType.AnimateActor,
      animateActorInteraction()
    );
    registerInteraction(
      InteractionType.StopWalking,
      stopWalkingInteraction()
    );
    registerInteraction(
      InteractionType.ProximityTrigger,
      proximityTriggerInteraction()
    );
    registerInteraction(
      InteractionType.SendActorToPosition,
      sendActorToPositionInteraction()
    );
    registerInteraction(InteractionType.SubSequence, subSequenceInteraction());
    registerInteraction(InteractionType.Trigger, triggerInteraction());
    registerInteraction(
      InteractionType.PlaySubSequence,
      playSubSequenceInteraction()
    );
    registerInteraction(
      InteractionType.StopSubSequence,
      stopSubSequenceInteraction()
    );
    registerInteraction(
      InteractionType.TriggerEvent,
      triggerEventInteraction()
    );
    registerInteraction(
      InteractionType.WaitForEvent,
      waitForEventInteraction()
    );
    registerInteraction(
      InteractionType.InitializeTimer,
      initializeTimerInteraction()
    );
    registerInteraction(InteractionType.UpdateTimer, updateTimerInteraction());
    registerInteraction(
      InteractionType.GetTimerTime,
      getTimerTimeInteraction()
    );
    registerInteraction(InteractionType.Transition, transitionInteraction());
    registerInteraction(
      InteractionType.ShowLetterBox,
      showLetterBoxInteraction()
    );
    registerInteraction(
      InteractionType.HideLetterBox,
      hideLetterBoxInteraction()
    );
    registerInteraction(InteractionType.If, ifInteraction());
    registerInteraction(InteractionType.Switch, switchInteraction());
    registerInteraction(InteractionType.Math, mathInteraction());
    registerInteraction(InteractionType.SetVariable, setVariableInteraction());
    registerInteraction(
      InteractionType.SetMovementEnabled,
      setMovementEnabledInteraction()
    );
    registerInteraction(
      InteractionType.EnableDefaultCamera,
      enableDefaultCameraInteraction()
    );
    registerInteraction(InteractionType.PowerSlide, powerSlideInteraction());
  }, []);

  return {};
}
